var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3327 4.00122C13.8599 4.00122 12.666 5.19513 12.666 6.66789V25.3346C12.666 26.8072 13.8599 28.0012 15.3327 28.0012H16.666C18.1388 28.0012 19.3327 26.8072 19.3327 25.3346V6.66789C19.3327 5.19513 18.1388 4.00122 16.666 4.00122H15.3327Z",
    fill: "#DB443A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 17.3347C5.19391 17.3347 4 18.5286 4 20.0014V25.3347C4 26.8074 5.19391 28.0014 6.66667 28.0014H8C9.47276 28.0014 10.6667 26.8074 10.6667 25.3347V20.0014C10.6667 18.5286 9.47276 17.3347 8 17.3347H6.66667Z",
    fill: "#DB443A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.334 13.3347C21.334 11.8619 22.5279 10.668 24.0007 10.668H25.334C26.8068 10.668 28.0007 11.8619 28.0007 13.3347V25.3347C28.0007 26.8073 26.8068 28.0013 25.334 28.0013H24.0007C22.5279 28.0013 21.334 26.8073 21.334 25.3347V13.3347Z",
    fill: "#DB443A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChart);
export default __webpack_public_path__ + "static/media/icon_chart.c4d4c22fdd71baef340ae62e4ae400a9.svg";
export { ForwardRef as ReactComponent };